import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiFilter, FiCalendar, FiMapPin, FiTag, FiRefreshCw, FiInfo } = FiIcons;

const CATEGORIES = ['All', 'Educators', 'Veterans', 'Artists', 'Community Leaders', 'Grandparents'];

const DATE_RANGES = [
  { id: 'all', label: 'All Time' },
  { id: 'recent', label: 'Past Year' },
  { id: '2020s', label: '2020 - Current' },
  { id: '2010s', label: '2010 - 2019' },
  { id: 'legacy', label: 'Before 2010' }
];

const ExploreFilters = ({ filters, onFilterChange, onReset }) => {
  return (
    <div className="bg-white rounded-[32px] border border-brand-dark p-6 md:p-8 shadow-sm space-y-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-brand-light rounded-xl flex items-center justify-center text-accent-navy">
            <SafeIcon icon={FiFilter} className="w-5 h-5" />
          </div>
          <h3 className="font-serif text-xl text-accent-navy">Refine Discovery</h3>
        </div>
        <button 
          onClick={onReset}
          className="text-[10px] font-black uppercase tracking-widest text-text-muted hover:text-accent-gold transition-colors flex items-center gap-2"
        >
          <SafeIcon icon={FiRefreshCw} className="w-3 h-3" /> Reset
        </button>
      </div>

      <div className="space-y-6">
        {/* Category Filter */}
        <div className="space-y-3">
          <label className="text-[10px] font-black uppercase tracking-widest text-accent-navy flex items-center gap-2">
            <SafeIcon icon={FiTag} className="text-accent-gold" /> Legacy Category
          </label>
          <div className="flex flex-wrap gap-2">
            {CATEGORIES.map(cat => (
              <button 
                key={cat}
                onClick={() => onFilterChange('category', cat)}
                className={`px-4 py-2 rounded-xl text-xs font-bold transition-all border-2 ${filters.category === cat ? 'bg-accent-navy border-accent-navy text-white shadow-md' : 'bg-white border-brand-dark text-text-muted hover:border-accent-gold'}`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Year Filter */}
        <div className="space-y-3">
          <label className="text-[10px] font-black uppercase tracking-widest text-accent-navy flex items-center gap-2">
            <SafeIcon icon={FiCalendar} className="text-accent-gold" /> Year of Passing
          </label>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            {DATE_RANGES.map(range => (
              <button 
                key={range.id}
                onClick={() => onFilterChange('dateRange', range.id)}
                className={`px-3 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-tighter transition-all border-2 ${filters.dateRange === range.id ? 'bg-accent-navy border-accent-navy text-white shadow-md' : 'bg-white border-brand-dark text-text-muted hover:border-accent-gold'}`}
              >
                {range.label}
              </button>
            ))}
          </div>
        </div>

        {/* Location Filter */}
        <div className="space-y-3">
          <label className="text-[10px] font-black uppercase tracking-widest text-accent-navy flex items-center gap-2">
            <SafeIcon icon={FiMapPin} className="text-accent-gold" /> Location / Region
          </label>
          <div className="relative">
            <SafeIcon icon={FiMapPin} className="absolute left-4 top-1/2 -translate-y-1/2 text-text-muted w-4 h-4" />
            <input 
              type="text" 
              placeholder="e.g. Seattle, WA" 
              className="w-full pl-10 pr-4 py-3 bg-brand-light border-2 border-brand-dark rounded-xl text-sm focus:border-accent-gold outline-none transition-all"
              value={filters.location}
              onChange={(e) => onFilterChange('location', e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="pt-6 border-t border-brand-light flex items-center gap-4">
        <div className="w-8 h-8 rounded-full bg-accent-gold/10 flex items-center justify-center text-accent-gold">
          <SafeIcon icon={FiInfo} className="w-4 h-4" />
        </div>
        <p className="text-[10px] text-text-muted leading-relaxed font-medium">
          Filters help find shared legacies within specific communities and professional backgrounds.
        </p>
      </div>
    </div>
  );
};

export default ExploreFilters;